// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AddonsType = { [key: string]: any | undefined };
export const addons: AddonsType = {};
